import './react'
import Tooltip from 'bootstrap/js/src/tooltip'
import 'bootstrap/js/src/modal'
import 'bootstrap/js/src/collapse'

window.bootstrap = {Tooltip}
